

export default function() {
  
  return [
    {
      title: 'Painel',
      to: "/home",
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: ""
    },
    {
      title: "Projetos",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/projetos",
    },
    
    {
      title: "Parceiros",
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/parceiros",
    },
    {
      title: "Usuários",
      htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/components-overview",
    }
    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: "/tables",
    // },
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/user-profile-lite",
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors",
    // }
  ];
}
